import axios from "../axios";

const SETTINGS_PATH = "/hse/settings";

function unwrap(response) {
  return response.data?.data || response.data;
}

export async function fetchHseSettings() {
  return axios.get(SETTINGS_PATH).then(unwrap);
}

export async function updateHseSettings(payload) {
  return axios
    .put(SETTINGS_PATH, {
      hse_settings: payload,
    })
    .then(unwrap);
}

/** @deprecated Use fetchHseSettings — same unified contract. */
export const fetchHseModuleSettings = fetchHseSettings;
/** @deprecated Use updateHseSettings — same unified contract. */
export const updateHseModuleSettings = updateHseSettings;
